import { render, staticRenderFns } from "./CdlEad.vue?vue&type=template&id=0024df94&scoped=true&"
import script from "./CdlEad.vue?vue&type=script&lang=js&"
export * from "./CdlEad.vue?vue&type=script&lang=js&"
import style0 from "./CdlEad.vue?vue&type=style&index=0&id=0024df94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0024df94",
  null
  
)

export default component.exports